<template>
  <div>
    <dialog-v2
      :show="show"
      :title="title"
      max-width="550px"
      @close="$emit('close')"
      @save="save">
      <template slot="content">
        <v-layout row wrap>
          <v-flex md10 pr-4>
            <v-text-field
              v-model="form.name"
              v-validate="'required|max:100'"
              data-vv-name="name"
              data-vv-scope="workflowFilter"
              data-vv-as="nombre"
              :error-messages="errors.collect('workflowFilter.name')"
              label="Nombre"
              color="black"/>
          </v-flex>
          <v-flex md2>
            <v-text-field
              v-model.number="form.order"
              v-validate="`required|integer|min_value:1|max_value:${maxOrder}`"
              data-vv-name="order"
              data-vv-scope="workflowFilter"
              data-vv-as="order"
              :error-messages="errors.collect('workflowFilter.order')"
              label="Orden"
              color="black"/>
          </v-flex>
        </v-layout>
        <v-subheader class="pl-0">
          Canales
        </v-subheader>
        <v-layout row wrap  mb-4>
          <v-flex
            md2
            v-for="channel in filteredChannels"
            :key="`channel-${channel.id}`"
            class="text-xs-center">
            <v-menu offset-y>
              <v-btn
                icon
                slot="activator"
                @click="templateChannel = channel.name"
                :class="{ 'k-orange-linear-text': form[`send_${channel.name}`] }"
                class="channels-btn">
                <v-icon>
                  {{ channel.icon }}
                </v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  @click="form[`send_${channel.name}`] = +(!form[`send_${channel.name}`])">
                  <v-list-tile-title>
                    {{ form[`send_${channel.name}`] ? 'Desactivar' : 'Activar' }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="openTemplateDialog">
                  <v-list-tile-title>Plantilla</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="['bot', 'sms', 'ivr', 'email'].includes(channel.name)
                  && (
                    (
                      channel.name !== 'bot'
                      && filter.template_id
                      && filter[channel.name]
                    )
                    || (
                      channel.name === 'bot'
                      && filter.id
                      && filter.bot_template_id
                    )
                  )"
                  @click="testTemplate(channel.id)">
                  <v-list-tile-title>Probar</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-space-between align-center>
          <v-flex>
            <v-subheader class="pl-0">
              Filtros
            </v-subheader>
          </v-flex>
          <v-flex md10 text-xs-right>
            <v-btn small depressed round class="k-orange-linear mr-0" @click.stop="filtersDialog = true">
              <v-icon small class="mr-1">
                fas fa-plus
              </v-icon>
              Agregar filtros
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <scrollbar style="height: 150px;">
              <table v-if="form.filters.length" class="pr-3" :key="tableKey">
                <tbody>
                  <template v-for="(item, i) in form.filters">
                    <tr v-if="item.connector" :key="`connector-${i}`" class="text-xs-center">
                      <td colspan="5">
                        <v-menu offset-y>
                          <v-chip slot="activator" class="my-3">
                            <strong class="mr-2">Conector:</strong>
                            {{ item.connector === 'and' ? 'Y' : 'O' }}
                          </v-chip>
                          <v-list>
                            <v-list-tile @click="changeConnector(i, 'and')">
                              <v-list-tile-title>
                                Y
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="changeConnector(i, 'or')">
                              <v-list-tile-title>
                                O
                              </v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                    <tr v-for="(item2, b) in item.content.items" :key="`items-${i}-${b}`">
                      <td :rowspan="item.content.items.length" v-if="!b" width="40px">
                        <v-btn
                          class="k-orange-linear"
                          @click="editGroup(i)"
                          small
                          icon
                          round>
                          <v-icon small>
                            fas fa-pencil-alt
                          </v-icon>
                        </v-btn>
                      </td>
                      <td
                        :rowspan="item.content.items.length" v-if="!b"
                        width="40px"
                        class="text-xs-center">
                        <v-btn
                          class="k-orange-linear"
                          @click="deleteFilter(i)"
                          small
                          icon
                          round>
                          <v-icon small>
                            fas fa-times
                          </v-icon>
                        </v-btn>
                      </td>
                      <td width="150px">
                        <h4>
                          {{ getFilterTitle(item2.field === 'partial_refinancing' || item2.field === 'total_refinancing' ? item2.field : `${item2.field}_id`) }}
                        </h4>
                      </td>
                      <td width="80px">
                        {{ getConditionName(item2.condition) }}
                      </td>
                      <td class="text-xs-center">
                        {{ getFilterValue(item2.field === 'partial_refinancing' || item2.field === 'total_refinancing' ? item2.field : `${item2.field}_id`, item2.value) }}
                      </td>
                      <td v-if="!b" :rowspan="item.content.items.length"
                        class="text-xs-center">
                        <strong>
                          {{ item.content.connector === 'and' ? 'Y' : 'O' }}
                        </strong>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <v-layout row wrap mt-5 v-else>
                <v-flex xs12 class="text-xs-center">
                  <v-icon small class="mr-3">
                    fas fa-info-circle
                  </v-icon>
                  <h3 class="d-inline-block">
                    No hay filtros que mostrar
                  </h3>
                </v-flex>
              </v-layout>
            </scrollbar>
          </v-flex>
        </v-layout>
      </template>
    </dialog-v2>
    <filters-list
      :show="filtersDialog"
      :group="selectedGroup"
      @new-filters="newFilters"
      @edit-filters="editFilters"
      @close="filtersDialog = false" />
    <template-dialog
      :show="templateDialog"
      :channel="templateChannel"
      :template="template"
      :append-vars="appendVars"
      @save="saveTemplate"
      @close="templateDialog = false" />
    <bot-templates-dialog
      :show="botTemplatesDialog"
      :selected="form.bot_template_id"
      @save="form.bot_template_id = $event"
      @close="botTemplatesDialog = false" />
    <test-template-dialog
      :show="testTemplateDialog"
      :template-id="testTemplateId"
      :channel="templateChannelId"
      @close="testTemplateDialog = false" />
  </div>
</template>

<script>
import _ from 'lodash';
import Scrollbar from 'vue-perfect-scrollbar';
import FiltersList from '@/components/CollectWorkflows/Detail/WorkflowTree/FiltersList';
import TemplateDialog from '@/components/Templates/Index';
import BotTemplatesDialog from '@/components/Templates/BotTemplates';
import TestTemplateDialog from '@/components/Templates/TestDialog';
import DialogV2 from '@/components/global/DialogV2';
import channelsMixin from '@/mixins/channelsV2';
import filtersMixin from '@/mixins/workflowFilters';
import EventBus from '@/event-bus';
import { setTimeout } from 'timers';

const uuidv1 = require('uuid/v1');

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    stage: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    Scrollbar,
    FiltersList,
    DialogV2,
    TemplateDialog,
    BotTemplatesDialog,
    TestTemplateDialog,
  },
  mixins: [
    channelsMixin,
    filtersMixin,
  ],
  data() {
    const emptyForm = {
      name: '',
      order: 0,
      company_email_id: null,
      bot_template_id: null,
      subject: '',
      send_human: 0,
      send_bot: 0,
      send_email: 0,
      send_sms: 0,
      send_ivr: 0,
      send_visit: 0,
      human: '',
      email: '',
      sms: '',
      ivr: '',
      visit: '',
      filters: [],
    };
    return {
      filtersDialog: false,
      templateDialog: false,
      botTemplatesDialog: false,
      testTemplateDialog: false,
      selectedGroupIndex: null,
      templateChannel: '',
      templateChannelId: 0,
      emptyForm,
      form: {
        ...emptyForm,
      },
      tableKey: uuidv1(),
      appendVars,
    };
  },
  computed: {
    maxOrder() {
      let order = (this.stage.filters || []).length;
      if (!Object.keys(this.filter).length) {
        order += 1;
      }
      return order;
    },
    testTemplateId() {
      let id = 0;
      if (this.templateChannelId === 4) {
        id = this.form.bot_template_id;
      } else {
        id = this.filter.template_id || 0;
      }
      return id;
    },
    title() {
      return `${!Object.keys(this.filter).length ? 'Crear' : 'Editar'} filtro`;
    },
    filterNames() {
      return this.filtersList.map(item => item.name);
    },
    filteredChannels() {
      return this.channels.filter(item => ['email', 'sms', 'ivr', 'bot', 'human', 'visit'].includes(item.name));
    },
    template() {
      return {
        ...this.templateChannel === 'email' && {
          company_email_id: this.form.company_email_id,
          subject: this.form.subject,
        },
        text: this.form[this.templateChannel] || '',
      };
    },
    selectedGroup() {
      let group = {};
      if (this.selectedGroupIndex !== null) {
        group = this.form.filters[this.selectedGroupIndex].content;
      }
      return group;
    },
  },
  methods: {
    testTemplate(id) {
      this.templateChannelId = id;
      this.testTemplateDialog = true;
    },
    openTemplateDialog() {
      if (this.templateChannel === 'bot') {
        this.botTemplatesDialog = true;
      } else {
        this.templateDialog = true;
      }
    },
    saveTemplate(form) {
      this.form = {
        ...this.form,
        ...this.templateChannel === 'email' && {
          company_email_id: form.company_email_id,
          subject: form.subject,
        },
        [this.templateChannel]: form.text,
      };
    },
    changeConnector(i, connector) {
      const filters = [
        ...this.form.filters,
      ];
      filters[i].connector = connector;
      this.form.filters = [
        ...filters,
      ];
      this.tableKey = uuidv1();
    },
    getConditionName(condition) {
      let name;
      /*
      if (condition === 'gt') {
        name = 'Mayor que';
      } else if (condition === 'lt') {
        name = 'Menor que';
      } else if (condition === 'eq') {
        name = 'Igual a';
      } else if (condition === 'neq') {
        name = 'Diferente de';
      }
      */
      if (condition === 'eq') {
        name = 'Igual a';
      } else {
        name = 'Diferente de';
      }
      return name;
    },
    newFilters(newFilters) {
      let filters = this.form.filters || [];
      filters = [
        ...filters,
        {
          ...filters.length && {
            connector: 'and',
          },
          content: newFilters,
        },
      ];
      this.form.filters = filters;
    },
    editGroup(i) {
      this.selectedGroupIndex = i;
      this.filtersDialog = true;
    },
    editFilters(filters) {
      this.form.filters[this.selectedGroupIndex].content = filters;
      this.selectedGroupIndex = null;
      this.tableKey = uuidv1();
    },
    save() {
      const wrongChannels = this.channels.filter(item => item.name !== 'bot' && item.name !== 'human')
        .filter(item => this.form[`send_${item.name}`] && !this.form[item.name]);
      if (this.form.send_bot && !this.form.bot_template_id) {
        wrongChannels.push({
          text: 'Bot',
        });
      }
      if (wrongChannels.length) {
        EventBus.$emit('modal', `Los siguientes canales no tienen texto: ${wrongChannels.map(item => item.text).join(', ')}.`);
      }
      const activeChannels = this.channels.filter(item => this.form[`send_${item.name}`]).length !== 0;
      if (!activeChannels) {
        EventBus.$emit('modal', 'Debe activar al menos un canal');
      } else {
        this.$validator.validateAll('workflowFilter').then((validation) => {
          if (validation && !wrongChannels.length) {
            const form = {
              ..._.omit(this.form, 'filters'),
            };
            form.filters = JSON.stringify(this.form.filters);
            if (Object.keys(this.filter).length) {
              this.axios.patch(`v2/workflow_filters/${this.filter.id}`, form)
                .then((response) => {
                  this.$emit('updated', response.data);
                  this.$emit('close');
                })
                .catch(() => {});
            } else {
              this.axios.post(`stages/${this.stage.id}/filters`, form)
                .then((response) => {
                  this.$emit('created', response.data);
                  this.$emit('close');
                }).catch(() => {});
            }
          }
        });
      }
    },
    deleteFilter(index) {
      this.form.filters.splice(index, 1);
    },
  },
  watch: {
    show() {
      if (!Object.keys(this.filter).length) {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
            order: this.stage.filters.length + 1,
          };
        }, 200);
      } else {
        this.form = {
          ..._.pick(this.filter, Object.keys(this.emptyForm)),
        };
      }
      if (!this.show) {
        setTimeout(() => {
          this.$validator.errors.remove('name', 'workflowFilter');
          this.$validator.errors.remove('order', 'workflowFilter');
        }, 500);
      }
    },
    filtersDialog() {
      if (!this.filtersDialog) {
        this.selectedGroupIndex = null;
      }
    },
  },
};
</script>

<style scoped>
table {
  width: 100% !important;
}
.btn.channels-btn {
  width: 50px;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/CollectWorkflows/Detail/WorkflowTree/FilterModal.vue